angular.module('hcap-analytics')
.controller('CsmCohortCtrl', [
  '$q',
  '$scope',
  '$state',
  '$transitions',
  'CohortsService',
  '$uibModal',
  'AlertService',
  'SurveyBundleService',
  'Util',
  function(
    $q,
    $scope,
    $state,
    $transitions,
    CohortsService,
    $uibModal,
    AlertService,
    SurveyBundleService,
    Util,
) {
  const cohortId = $state.params.id;

  $scope.data = {
    cohort: null,
    users: [],
    busy: false,
    bulkUploadSuccess: null,
    invitationBusy: {},
    csmStatus: null,
    csmStatusLoaded: false,
    csmStatusError: false,
  };

  const setup = (force) => {
    return $q.all([
      CohortsService.getId(cohortId, force),
      CohortsService.getUsers(cohortId),
    ]).then(([cohort, users]) => {
      $scope.data.cohort = cohort;
      $scope.data.users = users;
      $scope.data.busy = false;
      return loadCsmStatus();
    });
  };

  const loadCsmStatus = () => {
    $scope.data.csmStatusLoaded = false;
    $scope.data.csmStatusError = false;

    return SurveyBundleService.getCohortBundleStatus(cohortId).then(status => {
      $scope.data.csmStatus = status;
      $scope.data.csmStatusLoaded = true;
    }).catch(() => {
      $scope.data.csmStatusLoaded = true;
      $scope.data.csmStatusError = true;
    });
  };

  setup();

  $scope.toggleIntro = () => {
    $scope.data.introHide = !$scope.data.introHide;
  };

  $scope.finalize = () => {
    const parentScope = $scope;

    $uibModal.open({
      templateUrl: 'templates/partials/_finalizeCsmCohort.html',
      controller: ['$uibModalInstance', '$scope', ($uibModalInstance, $scope) => {
        $scope.ok = () => {
          if (!$scope.loading) {
            $scope.loading = true;

            CohortsService.finalize(parentScope.data.cohort._id).then(() => {
              parentScope.data.cohort.finalized = true;
              setup();
              $uibModalInstance.close();
              AlertService.alert('Cohort setup successfully finalized', 'Cohort Setup Finalized');
            }).catch(() => {
              $uibModalInstance.close();
              AlertService.error('Error', 'Cohort was not finalized, please try again.', 'Ok');
            });
          }
        };

        $scope.close = () => {
          $uibModalInstance.dismiss('cancel');
        };
      }],
    });
  };

  $scope.inviteUser = () => {
    const parentScope = $scope;
    const maxInvitees = parentScope.data.cohort.maxInvitees;
    if (maxInvitees && parentScope.data.users.length >= maxInvitees) {
      AlertService.warning(`Max invitees limit of ${maxInvitees} reached.`, 'Limit Reached');
      return;
    }

    $uibModal.open({
      templateUrl: 'templates/partials/_inviteParticipant.html',
      controller: ['$uibModalInstance', '$scope', ($uibModalInstance, $scope) => {
        $scope.data = {
          name: '',
          email: '',
        };

        $scope.ok = () => {
          if ($scope.data.form.$valid) {
            if (!$scope.data.busy) {
              if (maxInvitees && parentScope.data.users.length + 1 > maxInvitees) {
                AlertService.warning(`Cannot add participant. Max invitees limit of ${maxInvitees} would be exceeded.`, 'Limit Reached');
                return;
              }
              $scope.data.busy = true;
              CohortsService.uploadBulk(cohortId, [{
                ...$scope.data,
                team: '',
              }]).then(() => {
                setup();
                $uibModalInstance.close();
              });
            }
          } else {
            document.querySelectorAll('input').forEach(i => i.reportValidity());
          }
        };

        $scope.close = () => {
          $uibModalInstance.dismiss('cancel');
        };
      }],
    });
  };

  $scope.read = workbook => {
    const contents = Util.parseSheet(workbook);
    const participants = [];
    const regex = /[^a-zA-Z0-9@_\-\.]/gi;

    for (const sheetName in contents) {
      const sheetData = contents[sheetName];

      sheetData.forEach(row => {
        const name = row[Object.keys(row).find(k => k.match(/name/i))];
        const email = row[Object.keys(row).find(k => k.match(/email/i))];

        if (!name || !email) {
          return;
        }

        participants.push({
          name,
          email: email.toLowerCase().replace(regex, ''),
          team: '',
        });
      });
    }

    if (participants.length === 0) {
      AlertService.warning('No participants found in the file.', 'Error');
      return;
    }

    const maxInvitees = $scope.data.cohort.maxInvitees;
    if (maxInvitees && $scope.data.users.length + participants.length > maxInvitees) {
      AlertService.warning(
        `Import would exceed max invitees of ${maxInvitees}. Cohort has ${$scope.data.users.length} participant(s); importing ${participants.length} would bring it to ${$scope.data.users.length + participants.length}.`,
        'Import Blocked'
      );
      return;
    }

    CohortsService.uploadBulk(cohortId, participants).then(setup).then(() => {
      $scope.data.bulkUploadSuccess = true;
    }).catch(() => {
      $scope.data.bulkUploadSuccess = false;
    });
  };

  $scope.error = () => {
    $scope.data.bulkUploadSuccess = false;
  };

  $scope.removeUser = user => {
    if (!$scope.data.busy) {
      $scope.data.busy = true;
      AlertService.prompt(`Remove ${_.startCase(user.name)} completely from this cohort?`, 'Remove User', 'Remove User', 'Cancel', choice => {
        if (choice) {
          CohortsService.removeUser($scope.data.cohort._id, user._id).then(setup);
        }
      });
    }
  };

  $scope.resendBundleInvitation = function(participant) {
    if ($scope.data.invitationBusy[participant._id]) {
      return;
    }

    $scope.data.invitationBusy[participant._id] = true;
    SurveyBundleService.resendBundleInvitationCohort(cohortId, participant._id).then(() => {
      AlertService.alert('Bundle invitation resent.');
    }).finally(() => {
      $scope.data.invitationBusy[participant._id] = false;
    });
  };

  $scope.resendRaters = function(survey) {
    if (!survey.bundleParticipantGuid || survey.ratersCompleted === survey.ratersInvited) {
      return;
    }

    SurveyBundleService.resendRatersCohort(cohortId, survey.bundleParticipantGuid).then(res => {
      AlertService.alert(`${res.count} reminder email${res.count === 1 ? '' : 's'} resent.`);
      return loadCsmStatus();
    });
  };

  $scope.manageRaters = function(participant) {
    $uibModal.open({
      templateUrl: 'templates/partials/_csmRaterManager.html',
      controller: ['$uibModalInstance', '$scope', function($uibModalInstance, $scope) {
        $scope.data = {
          participant,
          bundleBusy: false,
          raterBusy: false,
        };

        $scope.resendBundleInvitation = function() {
          if ($scope.data.bundleBusy) {
            return;
          }

          $scope.data.bundleBusy = true;
          SurveyBundleService.resendBundleInvitationCohort(cohortId, participant._id).then(() => {
            AlertService.alert('Bundle invitation resent.');
          }).finally(() => {
            $scope.data.bundleBusy = false;
          });
        };

        $scope.resendRaters = function() {
          if (
            $scope.data.raterBusy ||
            !participant.bundleParticipantGuid ||
            participant.ratersCompleted === participant.ratersInvited
          ) {
            return;
          }

          $scope.data.raterBusy = true;
          SurveyBundleService.resendRatersCohort(cohortId, participant.bundleParticipantGuid).then(res => {
            AlertService.alert(`${res.count} reminder email${res.count === 1 ? '' : 's'} resent.`);
            return loadCsmStatus();
          }).then(() => {
            $uibModalInstance.close();
          }).finally(() => {
            $scope.data.raterBusy = false;
          });
        };

        $scope.close = function() {
          $uibModalInstance.dismiss('cancel');
        };
      }],
    });
  };

  const leaveHook = $transitions.onStart({from: 'cohort'}, transition => {
    if ($scope.data.cohort && !$scope.data.cohort.finalized) {
      return new Promise((resolve, reject) => {
        AlertService.confirm2('Would you like to continue?', 'Cohort Not Finalized', 'Continue', 'Go Back', choice => {
          choice ? resolve() : reject();
        });
      });
    }
  });

  $scope.$on('$destroy', () => {
    leaveHook();
  });
}]);
